export default function relationshipType(type) {
  if (type !== undefined) {
    return type.split('_').join(' ');
  } else {
    return '';
  }
}
